module.exports = __webpack_public_path__ + "media/images/div_lens/relatable-img3-81ad87f5c07f97c2b77e673e30b92b6a.png";